import { render, staticRenderFns } from "./BaseEdit.vue?vue&type=template&id=d291c7e4&"
import script from "./BaseEdit.vue?vue&type=script&lang=js&"
export * from "./BaseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports